/* eslint-disable camelcase */
import axios from '../axios'

const tradingList = {
  namespaced: true,
  state: {
    list: [],
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: false,
        value: '_id'
      },
      {
        text: 'Status',
        align: 'left',
        sortable: false,
        value: 'status'
      },
      {
        text: 'Nama & No K/P Pemohon',
        align: 'left',
        sortable: false,
        value: 'status'
      },
      {
        text: 'Tel / Emel Pemohon',
        align: 'left',
        sortable: false,
        value: 'status'
      },
      {
        text: 'Tarikh / Masa',
        align: 'left',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Tindakan',
        align: 'left',
        sortable: false,
        value: 'timestamp'
      }
    ],
    error: false,
    loading: false
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  actions: {
    fetchList: async function (context) {
      context.commit('setLoading', { loading: true })
      try {
        const queryOption = {
          startkey: [{}],
          endkey: [],
          reduce: false,
          descending: true
        }
        const response = await axios.post('/query', { url: btoa(`/apply_trading/_design/search/_view/list`), payload: queryOption })
        const list = response.data.rows.map(row => row.value)
        context.commit('setList', { list })
        context.commit('setError', { error: null })
        return response
      } catch (error) {
        context.commit('setError', { error: { message: 'Data Not Found' } })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    resetData (context) {
      context.commit('setError', { error: null })
      context.commit('setLoading', { loading: null })
      context.commit('setList', { list: [] })
    }
  },
  mutations: {
    setError (state, payload) {
      state.error = payload.error
    },
    setList (state, payload) {
      state.list = payload.list
    },
    setLoading (state, payload) {
      state.loading = payload.loading
    }
  }
}

export default tradingList
